import dayjs from "dayjs";

enum FORMAT_TIME {
  day = "DD/MM/YY",
  dayFull = "DD/MM/YYYY",
  dayFull2 = "DD-MM-YYYY",
  invertDayFull = "YYYY-MM-DD",
  dateTime = "HH:mm DD/MM/YYYY",
  dateTimes = "HH:mm:ss DD/MM/YYYY",
  dateTime_invert = "DD/MM/YYYY HH:mm",
  dateTime_2 = "DD-MM-YYYY HH:mm:ss ",
  dateTimeH = "DD/MM/YYYY HH:mm",
  time = "hh:mm:ss",
  dateTime_3 = "HH:mm:ss - DD/MM/YYYY",
  dateTime_4 = "YYYY-MM-DD 00:00:00",
  timeDetail = "YYYY-MM-DDTHH:mm:ss.SSSZ",
  time_24h = "HH:mm",
  time_24h_mili = "HH:mm:ss",
  hour = "HH",
  // dayFomat = dayjs().format('DD/MM/YYYY'),
  dayFullInput = "DDMMYYYY",
  dayFullInputRevert = "YYYYMMDD",
  timeZoneIOS_7 = "YYYY-MM-DDTHH:mm:ss.000+07:00",
  dayMonthYear = "[Ngày] DD [tháng] MM [năm] YYYY",
}
export { FORMAT_TIME };
